export const VALIDATE_PASSWORD = 'FORM/VALIDATE_PASSWORD'
